var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgOpenPositionsBg = function SvgOpenPositionsBg(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 395,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2226.19 463.491s-.01 32.516 3.26 136.379c3.26 103.863 16.51 68.643 10.79 130.292-5.71 61.649 53.67 45.664 39.97 111.043-13.7 65.38 38.16 115.607-85.77 109.131-123.05-6.305-340.99-51.593-418.38-64.088-77.4-12.494 168.74 672.702 100.91 666.992-67.84-5.71-1518.017-182.72-1570.871-190.8-52.924-7.71-163.166-47.05-283.1-55.39-120.81-8.51-188.2-521.07-312.38-535.536-124.252-14.101-250.21-235.481-329.12-263.398-78.909-27.916-103.011-85.567-61.58-130.397 41.431-44.829 16.841-132.446 25.121-188.677 7.407-56.402-4.316-93.86 60.811-143.884C-529.021-4.866-657.008-60.156-464.227-30-271.447.156 46.241 27.148 199.849 67.41c153.607 40.263 137.088 4.136 471.794 64.706 334.707 60.571 413.657 27.998 568.787 83.682 155.12 55.684 209.73 31.583 493.28 89.328 283.55 57.746 529.41 62.366 492.48 158.365Z",
    fill: "#F5D193"
  })));
};

export default SvgOpenPositionsBg;